import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AccountSummary = ({ user, securityInfo }) => {
  const summaryItems = [
    {
      label: 'Profile Completion',
      value: `${user.profileCompletion}%`,
      status: user.profileCompletion >= 80 ? 'good' : 'warning',
      action: 'Complete Profile',
      link: '/profile/edit'
    },
    {
      label: 'Email Verification',
      value: user.emailVerified ? 'Verified' : 'Pending',
      status: user.emailVerified ? 'good' : 'warning',
      action: user.emailVerified ? null : 'Verify Email',
      link: '/verify-email'
    },
    {
      label: 'Two-Factor Auth',
      value: user.twoFactorEnabled ? 'Enabled' : 'Disabled',
      status: user.twoFactorEnabled ? 'good' : 'warning',
      action: user.twoFactorEnabled ? null : 'Enable 2FA',
      link: '/security/2fa'
    },
    {
      label: 'Password Strength',
      value: securityInfo.passwordStrength,
      status: securityInfo.passwordStrength === 'Strong' ? 'good' : 'warning',
      action: securityInfo.passwordStrength !== 'Strong' ? 'Update Password' : null,
      link: '/security/password'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'good':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'good':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Info';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Account Summary</h2>
        <Link to="/settings">
          <Button variant="outline" size="sm" iconName="Settings" iconPosition="right">
            Settings
          </Button>
        </Link>
      </div>
      
      <div className="space-y-4">
        {summaryItems.map((item, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center space-x-3">
              <Icon 
                name={getStatusIcon(item.status)} 
                size={20} 
                className={getStatusColor(item.status)} 
              />
              <div>
                <p className="font-medium text-foreground">{item.label}</p>
                <p className={`text-sm ${getStatusColor(item.status)}`}>{item.value}</p>
              </div>
            </div>
            {item.action && (
              <Link to={item.link}>
                <Button variant="ghost" size="sm">
                  {item.action}
                </Button>
              </Link>
            )}
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-muted-foreground">
          <div>
            <p className="font-medium">Last Login</p>
            <p>{securityInfo.lastLogin}</p>
          </div>
          <div>
            <p className="font-medium">Member Since</p>
            <p>{user.memberSince}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSummary;